import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SubmitSolutionService {
  public solutionsVisible = false;
  public includeSubmit = false;
}